// libs
import React, { memo } from 'react';

// components
import ColorItem from './components/ColorItem';

// styles
import { Container } from './styles';

// defs
import { IColorSwatchesProps } from './types';

function ColorSwatches({ colorOptions, onItemClick, className = '' }: IColorSwatchesProps) {
  return (
    <Container className={className}>
      {colorOptions.map((colorItem, index: number) => {
        return <ColorItem item={colorItem} key={index} onItemClick={onItemClick} />;
      })}
    </Container>
  );
}

export default memo(ColorSwatches);
